export default "__VITE_ASSET__CIeTE9_o__"